<!-- Container -->
<div class="side-note-container" #container>
  <!-- Toggle for notes -->

  <div *ngIf="isRight" class="toggle" [style.right.px]="isOpen ? 350 : 10" (click)="toggleSideNotes()"></div>

  <div *ngIf="!isRight" class="toggle" [style.left.px]="isOpen ? 350 : 10" (click)="toggleSideNotes()"></div>

  <!-- Side note container -->
  <div class="side-notes"
    [@openClose]="isRight ? isOpen ? 'open' : 'closed' : isOpen ? 'left-open': 'left-closed'">
    <!-- Navbar -->
    <div class="notes-nav notes mb-3">
      <div>
        <!-- <i class="fa back mr-2" [ngClass]="{'fa-chevron-left': isRight, 'fa-chevron-right': !isRight}"
          (click)="toggleSideNotes()"></i> -->
        <span>Notes & Tasks</span>
      </div>
      <div>
        <i style="cursor: pointer;" class="fa fa-exchange mr-3"
          (click)="switch()"></i>
        <i class="fa fa-plus add" (click)="addNotes()"></i>
      </div>
    </div>

    <!-- List of notes -->
    <div cdkDropList [cdkDropListData]="sideNotes"
      (cdkDropListDropped)="drop($event)">
      <div class="notes mb-3" *ngFor="let note of sideNotes; let i = index" cdkDrag
        [ngClass]="{'pl-15': note.PRIORITY && note.PRIORITY != Priority.NONE}">
        <div class="priority" [ngClass]="{'high': note?.PRIORITY === Priority.HIGH, 'medium': note?.PRIORITY === Priority.MEDIUM, 'low': note?.PRIORITY === Priority.LOW}"></div>

        <!-- Report Name -->
        <div class="d-flex justify-content-end align-items-center" *ngIf="note.REPORT">
          <div class="report-name" (click)="goReport(note.REPORT)">
            <i class="fa fa-file-text-o mr-2"></i>{{note.REPORT?.primaryEntity()}}
          </div>
        </div>

        <!-- Notes -->
        <textarea [(ngModel)]="note.NOTE" class="form-control" placeholder="Notes" name="NOTES_{{i}}" autosize
          [minRows]="3" (blur)="onBlur(note.ID, 'NOTE', note.NOTE)"></textarea>

        <!-- Actions -->
        <div class="actions mt-3">
          <div class="d-flex">
            <!-- Priority -->
            <div class="hinted mr-3" dropdown dropdownToggle placement="bottom left">
              <i class="fa fa-exclamation-triangle"></i>
              <div class="hint">Priority</div>

              <!-- Options -->
              <div class="drop-menu dropdown-menu-right" *dropdownMenu style="left: 0;">
                <a class="drop-item" (click)="setPriority(note, Priority.HIGH)">
                  <fa name="fa fa-long-arrow-up"></fa>
                  <div class="item">High</div>
                </a>

                <a class="drop-item" (click)="setPriority(note, Priority.MEDIUM)">
                  <fa name="fa fa-long-arrow-up"></fa>
                  <div class="item">Medium</div>
                </a>

                <a class="drop-item" (click)="setPriority(note, Priority.LOW)">
                  <fa name="fa fa-long-arrow-down"></fa>
                  <div class="item">Low</div>
                </a>

                <a class="drop-item" (click)="setPriority(note, Priority.NONE)">
                  <fa name="fa fa-long-arrow-down"></fa>
                  <div class="item">None</div>
                </a>
              </div>
            </div>

            <!-- Delete Note -->
            <div class="hinted mr-3">
              <i class="fa fa-trash" (click)="removeNotes(note)"></i>
              <div class="hint">Delete Note</div>
            </div>

            <!-- Assign Report -->
            <div class="hinted mr-3">
              <i class="fa fa-id-card-o" (click)="assignReport(note)"></i>
              <div class="hint">Assign Report</div>
            </div>

            <!-- Reminder -->
            <div class="hinted mr-3" dropdown dropdownToggle placement="bottom left">
              <i class="fa fa-clock-o"></i>
              <div class="hint">Remind me</div>

              <!-- Options -->
              <div class="drop-menu dropdown-menu-right" *dropdownMenu style="left: 0;">
                <a class="drop-item" (click)="remindMe(note, Reminder.MINUTES_20)">
                  <div class="item ml-0">In 20 minutes</div>
                </a>

                <a class="drop-item" (click)="remindMe(note, Reminder.HOUR)">
                  <div class="item ml-0">In 1 hour</div>
                </a>

                <a class="drop-item" (click)="remindMe(note, Reminder.HOUR_3)">
                  <div class="item ml-0">In 3 hours</div>
                </a>

                <a class="drop-item" (click)="remindMe(note, Reminder.TOMORROW)">
                  <div class="item ml-0">Tomorrow</div>
                </a>

                <a class="drop-item" (click)="remindMe(note, Reminder.NEXT_WEEK)">
                  <div class="item ml-0">Next Week</div>
                </a>

                <a class="drop-item" (click)="remindMe(note, Reminder.CUSTOM)">
                  <div class="item ml-0">Custom</div>
                </a>
              </div>
            </div>

             <!-- Shared -->
             <ng-container *ngIf="note.USER">
                <div class="hinted mr-3" *ngIf="note.USER.ID == currentUser?.ID">
                  <i class="fa fa-share-alt" [ngClass]="{'share': note.SHARE}" (click)="shareNote(note)"></i>
                  <div class="hint">Share</div>
                </div>
             </ng-container>
          </div>
          <span class="note-time">{{note.CREATED_DATE | date: 'd/M/yy h:mm a'}}</span>
        </div>

         <div class="dialog mt-2" style="display: flex; align-content: center;" *ngIf="note.toShare">
           <span style="font-weight: bold;">Do you really want to share this Note? </span>
           <button type="button" class="btn btn-rbv default mr-1" (click)="note.toShare = false;">Cancel</button>
           <button tyupe="button" class="btn btn-rbv" (click)="confirmShare(note)">Confirm</button>
         </div>
      </div>
    </div>
  </div>
</div>
